<template>
  <div class="text-center mb-8">
    <h1 class="text-3xl md:text-4xl font-bold text-primary-dark mb-4">
      Você Não Precisa de Mais 'Motivação'<br>
      <span class="highlight text-primary-dark">Precisa de Clareza</span>
    </h1>
    <p class="text-lg md:text-xl text-gray-700 mb-4 max-w-3xl mx-auto">
      Escolha abaixo para desbloquear o plano exato que funciona para <b>VOCÊ</b>. Homem ou mulher, suas ações serão diferentes. Mas o resultado é o mesmo: <span class="text-primary font-medium">clareza total sobre o que fazer agora.</span>
    </p>
  </div>
</template>

<style scoped>
.highlight {
  background-color: rgba(160, 75, 153, 0.1);
  padding: 0.2rem 0.5rem;
  border-radius: 0.3rem;
}
</style>